import ProductionScheduleStore from "./ProductionSchedule/ProductionScheduleStore";
import ProductionOverviewScheduleStore from "./ProductionOverviewSchedule/ProductionOverviewScheduleStore";
import ScheduleGeneratorStore from "./ScheduleGenerator/ScheduleGenerator.Store";
import ScheduleGeneratorFormStore from "./ScheduleGenerator/ScheduleGeneratorForm.Store";

const schedulingStoreList = [
    { name: "productionScheduleStore", store: ProductionScheduleStore },
    { name: "productionOverviewScheduleStore", store: ProductionOverviewScheduleStore },
    { name: "scheduleGeneratorStore", store: ScheduleGeneratorStore },
    { name: "scheduleGeneratorFormStore", store: ScheduleGeneratorFormStore },
];

export default schedulingStoreList;
